import React, { useState, useEffect } from 'react';
import { AiOutlineStar } from 'react-icons/ai';
import { FiSettings } from 'react-icons/fi';
import { ImPlus } from 'react-icons/im';
import api from 'services/api';
import Loader from 'v3/components/Loader';
import Text from 'v3/components/Text';
import Link from 'v3/components/Link';
import useModal from 'hooks/useModal';
import { useSnackbar } from 'v3/components/Snackbar';
import FavoritesModal from './FavoritesModal';
import * as Styled from './styles';
import { verifyMostAcessedPermissions } from '../MostAccessed/validator';

function Favorites() {
  const favoritesModal = useModal();
  const snackbar = useSnackbar();

  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);

  async function getUserFavorites() {
    setLoading(true);
    try {
      const user_id = JSON.parse(localStorage.getItem('usuario')).id;
      const response = await api.get(`v3/user/favorites/${user_id}`);
      validateFavoritesPermission(response.data);
    } catch (err) {
      snackbar.show(<Text>Erro ao buscar seus favoritos</Text>, {
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  }

  const validateFavoritesPermission = (favorite) => {
    const validFavoritesRoutes = verifyMostAcessedPermissions(favorite);
    setSelected(validFavoritesRoutes);
  };

  useEffect(() => {
    getUserFavorites();
  }, []);

  return (
    <>
      <FavoritesModal
        selected={selected}
        setSelected={setSelected}
        isOpen={favoritesModal.isOpen}
        onClose={favoritesModal.close}
      />

      <Styled.SectionHeader>
        <Styled.SectionTitleWrap>
          <Styled.SectionIcon>
            <AiOutlineStar size={18} />
          </Styled.SectionIcon>
          <Text color="primary" weight="700" fontSize="36px">
            Favoritos
          </Text>
        </Styled.SectionTitleWrap>

        {!loading && (
          <Styled.EditButton
            onClick={() => {
              favoritesModal.open();
            }}
          >
            <FiSettings size={14} />
            Editar
          </Styled.EditButton>
        )}
      </Styled.SectionHeader>
      {!loading ? (
        <Styled.CardsGrid>
          {selected.length === 0 && (
            <Styled.AddingWrapper
              onClick={() => {
                favoritesModal.open();
              }}
              style={{ cursor: 'pointer' }}
            >
              <div className="d-flex flex-row align-items-center px-0">
                <div>
                  <ImPlus size={16} color="#1C4B75" className="mr-2" />
                </div>
                <div className="d-flex flex-column">
                  <Styled.Title color="dark" weight="700">
                    Adicionar favorito
                  </Styled.Title>
                </div>
              </div>
            </Styled.AddingWrapper>
          )}

          {selected?.map((item, index) => {
            return (
              <Link
                withoutIcon
                to={`${item.path}`}
                target="_blank"
                key={`${item.path}-${index}`}
              >
                <Styled.Wrapper>
                  <Styled.Title color="primary" weight="700">
                    {item.subtitle}
                  </Styled.Title>
                  <Text type="label">{item.path}</Text>
                </Styled.Wrapper>
              </Link>
            );
          })}
        </Styled.CardsGrid>
      ) : (
        <div className="d-flex justify-content-center mt-4">
          <Loader size="md" loading={loading} />
        </div>
      )}
    </>
  );
}

export default Favorites;
